import { Button } from '../ui/button';
import { X, Trash2 } from 'lucide-react';

const COLORS = ['#ffffff', '#000000', '#ff0000', '#ff6600', '#ffcc00', '#00ff00', '#00ccff', '#0066ff', '#9933ff', '#ff33cc'];
const SIZES = [2, 4, 8, 12, 20];

export default function DrawPanel({ color, setColor, size, setSize, onClear, onClose }) {
  return (
    <div className="bg-card border-t border-border p-3 space-y-3" data-testid="draw-panel">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium">Draw / Markup</span>
        <Button variant="ghost" size="icon" onClick={onClose}><X className="w-4 h-4" /></Button>
      </div>

      {/* Colors */}
      <div className="flex gap-1.5">
        {COLORS.map(c => (
          <button key={c} onClick={() => setColor(c)}
            className={`w-7 h-7 rounded-full border-2 transition-all ${color === c ? 'border-violet-400 scale-110' : 'border-transparent'}`}
            style={{ backgroundColor: c }} data-testid={`draw-color-${c}`} />
        ))}
      </div>

      {/* Size */}
      <div className="flex items-center gap-2">
        <span className="text-xs text-muted-foreground">Size:</span>
        {SIZES.map(s => (
          <button key={s} onClick={() => setSize(s)}
            className={`flex items-center justify-center transition-all ${size === s ? 'text-violet-400' : 'text-muted-foreground/60'}`}>
            <div className="rounded-full bg-current" style={{ width: s + 4, height: s + 4 }} />
          </button>
        ))}
      </div>

      {/* Clear */}
      <Button variant="outline" size="sm" onClick={onClear} className="gap-1" data-testid="draw-clear">
        <Trash2 className="w-3 h-3" /> Clear Drawing
      </Button>
    </div>
  );
}
